import React from "react";
import MaterialCustomDropDown from "widgets/DropDown/DropDown";
import { SearchWidget } from "widgets/SearchWidget/SearchWidget";

export default function DropDownSearchMix({
  handleAgentSearch,
  clearSearch,
  searchText,
  handleSearchEnter,
  onDropDownChange,
  dropDownData,
  dropDownChange,
}) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <MaterialCustomDropDown
        onDropDownChange={onDropDownChange}
        dropDownData={dropDownData}
      />
      <SearchWidget
        style={{ borderRadius: 0 }}
        onChange={handleAgentSearch}
        onClear={clearSearch}
        onEnter={(e) => handleSearchEnter(e)}
        value={searchText}
        placeholder={
          dropDownChange
            ? "Search By " +
              dropDownData.find((i) => {
                return i.value == dropDownChange;
              }).placeholder
            : "Search By " + dropDownData[0].placeholder
        }
      />
    </div>
  );
}
